<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  @if (!isEditing && federalTax) {
    <div>
      <mwp-federal-tax-form title="Current Federal Taxes" [isEditing]="isEditing" [federalTax]="federalTax" />
      @if (displayTopRequestButton) {
        <div class="d-flex justify-content-end mb-3">
          <button class="mwp-button" (click)="newChangeRequest()">
            <mwp-text-translate [text]="buttonText" [jsonKey]="buttonText" />
          </button>
        </div>
      }
      @if (displayPendingOrDeniedRequest) {
        <div class="mb-3">
          <mwp-federal-tax-form [title]="pendingOrDeniedHeader" [isEditing]="isEditing" [ChangeRequestFederalTaxModel]="currentChangeRequestFederalTaxModel" />
        </div>
      }
      @if (!displayTopRequestButton) {
        <div class="d-flex justify-content-end">
          <button class="mwp-button" (click)="editChangeRequest()">
            <mwp-text-translate [text]="buttonText" [jsonKey]="buttonText" />
          </button>
        </div>
      }
    </div>
  }
  @if (isEditing) {
    <div>
      <mwp-federal-tax-form title="New Change Request" [isEditing]="isEditing" [ChangeRequestFederalTaxModel]="changeRequestFormModel" (cancelEmit)="cancelEdit($event)"/>
    </div>
  }
</div>